import React from 'react';
import styled, { css } from 'styled-components';
import Img from 'gatsby-image';
import { GatsbyImage } from 'gatsby-plugin-image';
import Box from '../Box/Box';

const StyledImage = styled.img<{
    height?: string;
    width?: string;
    objectFit?: string;
    objectPosition?: string;
}>`
    object-fit: ${({ objectFit }) => objectFit || 'contain'};
    object-position: ${({ objectPosition }) => objectPosition || '50% 50%'};
    height: ${({ height }) => height || 'auto'};

    ${({ width }) => css`
        width: ${width};
    `}
`;

type ImageProps = {
    img: any;
    sharp?: any;
    height?: string;
    width?: string;
    objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
    objectPosition?: string;
};

const Image = React.forwardRef<HTMLDivElement, ImageProps>(
    (
        {
            img,
            sharp,
            height,
            width,
            objectFit = 'contain',
            objectPosition = '50% 50%',
            ...props
        },
        ref
    ) => {
        const svg =
            img?.localFile?.childInlineSvg?.content ||
            sharp?.childInlineSvg?.content;
        if (svg) {
            return (
                <Box
                    ref={ref}
                    style={{
                        height,
                        width,
                    }}
                    css={css`
                        svg {
                            ${height &&
                            css`
                                height: ${height};
                            `}
                            ${width &&
                            css`
                                width: ${width};
                            `}
                        }
                    `}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: svg,
                    }}
                />
            );
        }
        const fluid = img.fluid || sharp?.childImageSharp?.fluid;
        const fixed = img.fixed || sharp?.childImageSharp?.fixed;
        if (fluid || fixed) {
            return (
                <Box ref={ref}>
                    <Img
                        height={height}
                        width={width}
                        fixed={fixed}
                        fluid={fluid}
                        alt={img.alt}
                        imgStyle={{
                            objectFit,
                            objectPosition,
                        }}
                        {...props}
                    />
                </Box>
            );
        }

        if (img?.gatsbyImageData) {
            return (
                <Box ref={ref}>
                    <GatsbyImage
                        alt={img.alt}
                        image={img.gatsbyImageData}
                        style={{
                            height,
                            width,
                        }}
                        imgStyle={{
                            objectFit,
                            objectPosition,
                        }}
                        {...props}
                    />
                </Box>
            );
        }

        return (
            <Box ref={ref}>
                <StyledImage
                    src={img.url}
                    alt={img.alt || ''}
                    height={height}
                    width={width}
                    objectFit={objectFit}
                    objectPosition={objectPosition}
                    css={css}
                    {...props}
                />
            </Box>
        );
    }
);

export default Image;
